import { Component, inject } from '@angular/core';
import { FirebreakTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FirebreakTypeCreateDto,
  FirebreakTypeDto,
  FirebreakTypeExcelDownloadDto,
  FirebreakTypeUpdateDto,
} from '../proxy/planning/dtos/firebreak-type';
import { FIREBREAKTYPE_CONFIG, FIREBREAKTYPE_FIELDS } from './firebreak-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-firebreak-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FirebreakTypeService, ConfirmationService],
  templateUrl: './firebreak-type.html',
  styleUrl: './firebreak-type.scss',
})
export class FirebreakType extends BaseCrudComponent<
  FirebreakTypeDto,
  FirebreakTypeCreateDto,
  FirebreakTypeUpdateDto,
  FirebreakTypeExcelDownloadDto
> {
  service = inject(FirebreakTypeService);
  config = FIREBREAKTYPE_CONFIG;
  fields = FIREBREAKTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: FirebreakTypeDto): FirebreakTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FirebreakType';
  }
}
